import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
import IconButton from '@mui/material/IconButton'
import screenfull from 'screenfull'

const FullscreenControl = ({ parentRef, isFullscreen }) => {
  const requestFullscreen = () => {
    if (isFullscreen) {
      screenfull.exit()
    } else {
      screenfull.request(parentRef?.current?.parentNode)
    }
  }

  return (
    <IconButton color="inherit" sx={{ padding: 0, ml: 2 }} onClick={requestFullscreen}>
      {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
    </IconButton>
  )
}

export default FullscreenControl
